export const ShortName = (email?: string | null, name?: string | null) => {
  if (name) {
    return name.split(' ')[0];
  }
  if (email) {
    return email.split('@')[0];
  }
  return 'Anonymous';
};
